<div class="row">
  <div class="col-12">
    <div class="nav-bg" *ngIf="!isMobileView">
      <div class="navigation"
        style="height: 100%;width: 99%; display: flex; align-items: center; justify-content: space-between;top: 0px;">
        <div style="display: flex; align-items: center; height: 100%;">
          <a routerLink="/Webinar-rooms" class="brand-logo logoPosition" aria-label="LootLucky Home">
            <img src="../../assets/Images/logo_image.png" alt="" class="brand-logo-icon" />
            <img src="../../assets/Images/logo_text.png" alt="LootLucky" class="brand-logo-text" />
          </a>
        </div>
        <nav class="room-nav" aria-label="Webinar rooms">
          <a
            *ngFor="let room of webinarRooms"
            class="room-nav__link"
            routerLink="/Webinars/{{room.roomId}}"
            routerLinkActive="active"
            (click)="onMenuClick(); onOpenLink(room.roomId)">
            <span class="room-nav__dot" aria-hidden="true"></span>
            <span>{{room.roomName}}</span>
          </a>
        </nav>

        <div class="menu">
          <span matTooltip="Verify Email, Verificatio link will be sent on registered emailId" (click)="onVerifyEmail()"
            *ngIf="!isEmailVerified" style="color: rgb(252, 250, 250); font-weight: bold; margin-left: 8px;">*Verify
            Email &nbsp;</span>

          <a class="lucky-bucks-container" *ngIf="userLoggedIn && userDetails !== undefined && userDetails !== null"
            routerLink="/MyAccount/4"
            aria-label="Lucky Bucks — open Payment Methods in My Account">
            <img src="../../assets/Images/lucky-bucks-icon-1.png" alt="Lucky Bucks" class="lucky-bucks-icon"
              matTooltip="{{walletBalance | currency:'USD':'symbol':'1.0-2'}} Lucky Bucks"
              [matTooltipDisabled]="isLoadingWallet">
            <span class="wallet-balance-badge" *ngIf="!isLoadingWallet && walletBalance > 0">
              {{walletBalance | currency:'USD':'symbol':'1.0-2'}}
            </span>
            <span class="wallet-balance-badge loading" *ngIf="isLoadingWallet">
              ...
            </span>
          </a>
          <a *ngIf="userDetails !== undefined && userDetails !== null" routerLink="Cart"
            class="search cart-wrapper tablet-rec-cart-wrap" style="margin-left: 8px;">
            <span class="cart-icon">🛒</span>
            <span class="item-count tablet-rec-cart-badge">{{cartCount}}</span>
          </a>
          <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Menu" style="margin-left: 8px;">
            <mat-icon>menu</mat-icon>
          </button>
          <span class="blinking-text" *ngIf="cartRemainingTime !== '' && cartRemainingTime !== '0'"
            style="margin-left: 8px; font-size: 14px;">
            {{cartRemainingTime}} &nbsp;
          </span>
          <mat-menu #menu="matMenu" class="casino-menu" panelClass="casino-menu" backdropClass="casino-menu-dim" xPosition="before" [hasBackdrop]="true">
            <ng-container *ngTemplateOutlet="accountMenuLinks"></ng-container>
          </mat-menu>
        </div>
      </div>
    </div>


    <ng-container *ngIf="isMobileView">
      <div class="nav-bg" [ngClass]="isTabletPortraitHeader ? 'nav-bg--tablet-recommended' : 'nav-bg--mobile-phone-row'"
        style="overflow: hidden; position: relative;">

        <!-- iPad / tablet (portrait, width >= 768): recommended 3-zone header -->
        <div *ngIf="isTabletPortraitHeader" class="navigation mobile-nav tablet-rec-nav">
          <div class="tablet-rec-left">
            <a routerLink="/Webinar-rooms" class="tablet-rec-brand" aria-label="LootLucky Home">
              <img src="../../assets/Images/logo_image.png" alt="" class="tablet-rec-brand-icon" />
              <img src="../../assets/Images/logo_text.png" alt="LootLucky" class="tablet-rec-brand-text" />
            </a>
            <span class="tablet-rec-brand-rule" aria-hidden="true"></span>
          </div>
          <div class="tablet-rec-center">
            <a routerLink="/MyAccount/4" class="tablet-rec-bucks-pill"
              *ngIf="userLoggedIn && userDetails !== undefined && userDetails !== null"
              matTooltip="View account and wallet"
              aria-label="Lucky Bucks balance, go to My Account">
              <img src="../../assets/Images/lucky-bucks-icon-1.png" alt="" class="tablet-rec-bucks-icon" />
              <span class="tablet-rec-bucks-text" *ngIf="!isLoadingWallet">
                {{ walletBalance | currency:'USD':'symbol':'1.0-2' }} Lucky Bucks
              </span>
              <span class="tablet-rec-bucks-text tablet-rec-bucks-text--loading" *ngIf="isLoadingWallet">…</span>
              <mat-icon class="tablet-rec-bucks-chevron" aria-hidden="true">chevron_right</mat-icon>
            </a>
          </div>
          <div class="tablet-rec-right">
            <span class="blinking-text" *ngIf="cartRemainingTime !== '' && cartRemainingTime !== '0'">
              {{cartRemainingTime}} &nbsp;
            </span>
            <span *ngIf="userDetails !== undefined && userDetails !== null">
              <span matTooltip="Verify Email, Verificatio link will be sent on registered emailId"
                (click)="onVerifyEmail()" *ngIf="!isEmailVerified"
                class="tablet-rec-verify">*Verify Email &nbsp;</span>
              <a routerLink="Cart" class="cart-wrapper tablet-rec-cart-wrap">
                <span class="cart-icon-mobile">🛒</span>
                <span class="item-count-mobile tablet-rec-cart-badge">{{cartCount}}</span>
              </a>
            </span>
            <button mat-icon-button [matMenuTriggerFor]="menuMobile" aria-label="Menu" class="tablet-rec-menu-btn">
              <mat-icon>menu</mat-icon>
            </button>
          </div>
        </div>

        <!-- Phone: brand left | trailing: timer, verify | separator + lucky bucks + cart + menu -->
        <div *ngIf="!isTabletPortraitHeader" class="navigation mobile-nav mobile-nav--phone-single">
          <a routerLink="/Webinar-rooms" class="mobile-brand-logo mobile-brand-logo--phone-left"
            aria-label="LootLucky Home">
            <img src="../../assets/Images/logo_image.png" alt="" class="mobile-brand-logo-icon" />
            <img src="../../assets/Images/logo_text.png" alt="LootLucky" class="mobile-brand-logo-text" />
            <img src="../../assets/Images/logo_image.png" alt="" class="mobile-brand-logo-icon mobile-brand-logo-icon--mirror"
              aria-hidden="true" />
          </a>
          <div class="mobile-nav-phone-trailing">
            <span class="blinking-text" *ngIf="cartRemainingTime !== '' && cartRemainingTime !== '0'">
              {{cartRemainingTime}} &nbsp;
            </span>
            <span *ngIf="userDetails !== undefined && userDetails !== null">
              <span matTooltip="Verify Email, Verificatio link will be sent on registered emailId"
                (click)="onVerifyEmail()" *ngIf="!isEmailVerified"
                style="color: rgb(252, 250, 250); font-weight: bold; font-size: 11px;">*Verify Email &nbsp;</span>
            </span>
            <span class="mobile-nav-phone-separator mobile-nav-phone-separator--before-bucks"
              aria-hidden="true"></span>
            <a class="lucky-bucks-container-mobile lucky-bucks-container-mobile--link lucky-bucks-mobile--trailing"
              *ngIf="userLoggedIn && userDetails !== undefined && userDetails !== null"
              routerLink="/MyAccount/4"
              aria-label="Lucky Bucks — open Payment Methods in My Account">
              <span class="wallet-balance-badge-mobile" *ngIf="!isLoadingWallet">
                {{ walletBalance | currency:'USD':'symbol':'1.0-2' }}
              </span>
              <span class="wallet-balance-badge-mobile loading" *ngIf="isLoadingWallet">…</span>
              <img src="../../assets/Images/lucky-bucks-icon-1.png" alt="" class="lucky-bucks-icon-mobile lucky-bucks-icon-mobile--trail"
                matTooltip="{{walletBalance | currency:'USD':'symbol':'1.0-2'}} Lucky Bucks"
                [matTooltipDisabled]="isLoadingWallet">
            </a>
            <a *ngIf="userDetails !== undefined && userDetails !== null" routerLink="Cart"
              class="cart-wrapper cart-wrapper--phone-header">
              <span class="cart-icon-mobile">🛒</span>
              <span class="item-count-mobile item-count-mobile--phone-header">{{cartCount}}</span>
            </a>
            <button mat-icon-button [matMenuTriggerFor]="menuMobile" aria-label="Menu" class="mobile-nav-menu-btn">
              <mat-icon>menu</mat-icon>
            </button>
          </div>
        </div>
      </div>

      <mat-menu #menuMobile="matMenu" class="casino-menu" panelClass="casino-menu" backdropClass="casino-menu-dim" xPosition="before" [hasBackdrop]="true">
        <ng-container *ngTemplateOutlet="accountMenuLinks"></ng-container>
      </mat-menu>
    </ng-container>

  </div>
</div>

<ng-template #accountMenuLinks>
  <button mat-menu-item routerLink="HowItWorks" (click)="onOpenLink()">
    <span class="casino-menu__icon casino-menu__icon--gold"><mat-icon>help_outline</mat-icon></span>
    <span>How It Works</span>
  </button>
  <button mat-menu-item routerLink="TermConditions" (click)="onOpenLink()">
    <span class="casino-menu__icon casino-menu__icon--lilac"><mat-icon>checklist</mat-icon></span>
    <span>Terms & Conditions</span>
  </button>
  <button mat-menu-item routerLink="HostingTerms" (click)="onOpenLink()">
    <span class="casino-menu__icon casino-menu__icon--gold"><mat-icon>mic</mat-icon></span>
    <span>Hosting Terms</span>
  </button>
  <button mat-menu-item routerLink="Policies" (click)="onOpenLink()">
    <span class="casino-menu__icon casino-menu__icon--teal"><mat-icon>policy</mat-icon></span>
    <span>Privacy Policy</span>
  </button>
  <button mat-menu-item routerLink="RefundPolicy" (click)="onOpenLink()">
    <span class="casino-menu__icon casino-menu__icon--coral"><mat-icon>money_off</mat-icon></span>
    <span>Refund Policy</span>
  </button>
  <button mat-menu-item routerLink="PaymentPolicy" (click)="onOpenLink()">
    <span class="casino-menu__icon casino-menu__icon--gold"><mat-icon>payments</mat-icon></span>
    <span>Payment Policy</span>
  </button>
  <button mat-menu-item routerLink="ShippingPolicy" (click)="onOpenLink()">
    <span class="casino-menu__icon casino-menu__icon--teal"><mat-icon>local_shipping</mat-icon></span>
    <span>Shipping Policy</span>
  </button>
  <button mat-menu-item routerLink="DisputePolicy" (click)="onOpenLink()">
    <span class="casino-menu__icon casino-menu__icon--lilac"><mat-icon>gavel</mat-icon></span>
    <span>Resolution & Dispute</span>
  </button>
  <button mat-menu-item routerLink="AboutUs" (click)="onOpenLink()">
    <span class="casino-menu__icon casino-menu__icon--gold"><mat-icon>info</mat-icon></span>
    <span>About W.O.W.</span>
  </button>
  <button mat-menu-item routerLink="faqs" (click)="onOpenLink()">
    <span class="casino-menu__icon casino-menu__icon--lilac"><mat-icon>quiz</mat-icon></span>
    <span>FAQ</span>
  </button>
  <button mat-menu-item routerLink="Contact" (click)="onOpenLink()">
    <span class="casino-menu__icon casino-menu__icon--teal"><mat-icon>call</mat-icon></span>
    <span>Contact Us</span>
  </button>
  <button mat-menu-item class="casino-menu__danger" *ngIf="userLoggedIn" (click)="Logout()">
    <span class="casino-menu__icon casino-menu__icon--hot"><mat-icon>logout</mat-icon></span>
    <span>Logout</span>
  </button>
  <button mat-menu-item routerLink="/login" *ngIf="!userLoggedIn">
    <span class="casino-menu__icon casino-menu__icon--gold"><mat-icon>login</mat-icon></span>
    <span>Login</span>
  </button>
  <a
    mat-menu-item
    class="casino-menu__user"
    routerLink="/MyAccount"
    (click)="onOpenLink()"
    *ngIf="userLoggedIn && userDetails"
    aria-label="My Account">
    <span class="casino-menu__avatar"><mat-icon>person</mat-icon></span>
    <span>{{ userDetails.firstName }} {{ userDetails.lastName }}</span>
  </a>
</ng-template>